export default {
  newDesign: true,
  parameters: {
    landing_id: "GCCQC",
    segment: 59,
  },
  title: "وراء كل لعبة رائعة مبرمج رائع | Kodland",
  downtimeUrl: "https://www.kodland.org",
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "شكراً لثقتك في منصتنا التعليمية!",
    subtitle:
      "لسوء الحظ، الأجهزة اللوحية (التابلت) أو الهواتف الذكية غير مناسبة لحضور دروسنا. سنكون سعداء برؤيتكم في فصولنا في المرة القادمة!",
  },
  customStopPages: {
    egypt: {
      image: "/welcome/quizV2/no-computer.png",
      title: "شكراً لاهتمامكم بـ Kodland!",
      subtitle:
        "لسوء الحظ، خدماتنا ومنصتنا التعليمية غير متاحة مؤقتاً في مصر في الوقت الحالي. نحن نعمل جاهدين لفتح التسجيل في منطقتكم قريباً.",
    },
  },
  quizRotateBySteps: {
    1: {
      type: "age-start",
      title: "كم عمر طفلك؟",
      image: {
        url: "/welcome/coding_gcc_desk.png",
      },
      imageMobile: {
        url: "/welcome/coding_gcc_mob.png",
      },
    },
    2: {
      question: "ما هي بلد إقامتكم الحالية؟",
      answers: [
        "🌐 دولة أخرى",
        {
          answer: "🇪🇬 مصر",
          stopAnswer: true,
          customStopPageId: "egypt",
        },
      ],
    },
    3: {
      question:
        "هل تود أن يكون الوقت الذي يقضيه طفلك على الكمبيوتر أكثر إنتاجية؟",
      answers: [
        "🔥 نعم!",
        "🤗 لا. إنه يفعل ذلك من أجل المتعة فقط وهذا أمر جيد.",
      ],
    },
    4: {
      question: "ما هي المادة المفضلة لطفلك في المدرسة؟",
      answers: [
        "اللغة العربية",
        "الرياضيات",
        "العلوم",
        "التاريخ",
        "الجغرافيا",
        "الفنون",
      ],
    },
    5: {
      question: "في الوقت الحالي، ما هو الأهم بالنسبة لك في تطور طفلك؟",
      answers: [
        "🤔 المهارات الشخصية",
        "🎓 التحضير لمسيرة مهنية في المستقبل",
        "🖥️ الأنشطة اللامنهجية",
      ],
    },
    6: {
      question: "هل لديك جهاز كمبيوتر مكتبي/لابتوب يمكن لطفلك استخدامه؟",
      answers: [
        "💻 نعم",
        {
          answer: "😐 لا",
          stopAnswer: true,
        },
      ],
    },
    7: {
      title: "تهانينا! 🎉",
      typeInfo: "congrats",
      subtitle: 'اضغطي على "📆 احجزي حصة" لإكمال التسجيل',
      button: "📆 احجزي حصة",
    },
    8: {
      title:
        "سجل الآن للحصول على حصة مجانية في بايثون (Python) أو ماينكرافت (Minecraft)",
      type: "one-page-contacts",
      subtitle: "",
      button: "اقتربنا من النهاية 🔥",
    },
    9: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    10: {
      title: "راجع هذه التفاصيل لإكمال التسجيل ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "يُرجى ملاحظة أنك ستحتاج إلى جهاز كمبيوتر أو لابتوب يعمل لحضور الحصة، ويجب أن ترافق طفلك طوال مدة الدرس. تذكر أن الحصة فردية ومخصصة بالكامل لطفلك.",
      button: "ماذا أيضاً؟",
    },
    11: {
      title: "تحقق من بريدك الإلكتروني وواتساب قبل الحصة التجريبية 📞",
      typeInfo: "whatsapp",
      subtitle:
        "سنقوم بإرسال تذكير لك قبل 24 ساعة، وقبل ساعتين من الحصة سنطلب منك تأكيد الحضور. من المهم جداً أن نبقى على تواصل حتى لا يتم إلغاء الحصة.",
      button: "ماذا أيضاً؟",
    },
    12: {
      title: "الحصة ستُعقد على منصتنا 💻",
      typeInfo: "classroom",
      subtitle:
        "ستصلك رسالة برابط ورمز خاص عبر واتساب والبريد الإلكتروني. فقط اضغط على الرابط لتنتقل مباشرة إلى الحصة. لا حاجة لتطبيقات إضافية أو تحميل.",
      button: "حسناً ✅",
    },
  },
};
